export default function syncAssetDirective() {
  return {
    template: require('./sync-asset.html'),
    restrict: 'E',
    controller: 'SyncAssetController',
    controllerAs: 'syncAssetVM',
    bindToController: true,
    replace: true,
    scope: {
      asset: '=',
      tooltipAppendToSelector: '@',
      process: '<',
      showType: '<',
      showCriticality: '<',
      showDataUsage: '<',
      showNotes: '<',
      showRiskCount: '<',
      showRiskControlCount: '<',
      showActionIcons: '<',
      assetType: '<',
      showBulkDelete: '<',
      showSyncAsset: '<'
    },
  };
}
